import { DICWindow } from '../typedefs/window';

declare var window: DICWindow;

export default function createMiddleware() {
    return (store: any) => (next: any) => (action: any) => {
        if (window.DIConv.Bugsnag) {
            (window.DIConv.Bugsnag as any).leaveBreadcrumb(action.type, action.payload || {});
        }

        return next(action);
    };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/store/BreadcrumbLoggerMiddleware.ts